import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import { createVNode as h, Component } from 'intact-react';
import { typeDefs } from './constants';
import { PanelPicker } from './panelPicker';
import { SelectPicker } from './selectPicker';
export var Timepicker = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Timepicker, _Component);
  function Timepicker() {
    return _Component.apply(this, arguments) || this;
  }
  Timepicker.template = function template() {
    var props = this.get();
    if (props.step && !props.range) {
      return h(SelectPicker, props);
    }
    return h(PanelPicker, props);
  };
  return Timepicker;
}(Component);
// declare class _Timepicker<
// Multipe extends boolean = false,
// Range extends boolean = false,
// > extends PanelPicker<Multipe, Range> { } 
// function Wrapper(props: TimepickerProps) {
// if (props.step && !props.range) {
// return h(SelectPicker, props);
// }
// return h(PanelPicker, props);
// }
// const functionalWrapper = (Component as any).functionalWrapper;
// export const Timepicker: typeof _Timepicker = functionalWrapper ?
// functionalWrapper(Wrapper) : Wrapper;
Timepicker.$doubleVNodes = true;
Timepicker.typeDefs = typeDefs;